import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ShoppingCartState } from '../../../shopping-cart-back/actions/standalone';
import { selectShoppingCartId } from '../../../shopping-cart-back/actions/selector';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SinglePhotoProductOptionsService {
  shoppingCartId$ = this.store.pipe(select(selectShoppingCartId));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  save(x) {
    this.shoppingCartId$.pipe(first()).subscribe((shoppingCartId) => {
      localStorage.setItem(
        `${shoppingCartId}_noPackagePackage`,
        JSON.stringify(x)
      );
    });
  }

  load() {
    let shoppingCartId = '';
    this.shoppingCartId$.pipe(first()).subscribe((x) => {
      shoppingCartId = x;
    });
    return JSON.parse(
      localStorage.getItem(`${shoppingCartId}_noPackagePackage`)
    );
  }
}
